import { Geometry } from '@highimpact-frontend/map-geometry';
import { useMemo } from 'react';
import { Marker, Polygon, Polyline } from 'react-leaflet';
import { Icon } from 'leaflet';

const LeafIcon = Icon.extend({
  options: {
    iconUrl: '/images/map-pin.svg',
    iconSize: [32, 32],
    iconAnchor: [16, 32],
    popupAnchor: [0, -24],
  },
});

export const pin = new LeafIcon();

export function useLeaflet(
  data: Geometry<number, number> | Geometry<number, number>[]
) {
  return useMemo(() => {
    const geometryElements = Array.isArray(data) ? data : [data];
    return geometryElements.map((geometry, index) => {
      if (geometry) {
        switch (geometry.type) {
          case 'POINT':
            return (
              <Marker
                key={index}
                position={geometry.coordinates}
                icon={pin}
              ></Marker>
            );
          case 'POLYGON':
            return (
              <Polygon key={index} positions={geometry.coordinates}></Polygon>
            );
          case 'LINE':
            return (
              <Polyline key={index} positions={geometry.coordinates}></Polyline>
            );
          default:
            return null;
        }
      }
    });
  }, [data]);
}
